import React, { useEffect, useState, useCallback } from 'react';
import ServiceDetails from './AddItemComps/ServiceDetails';
import CourseDetails from './AddItemComps/CourseDetails';
import OtherDetails from './AddItemComps/OtherDetails';
import ProductDetails from './AddItemComps/ProductDetails';
import { toast, ToastContainer } from 'react-toastify';
import { addCourse, addProduct, addService } from '../../../API/functions';
import { useFileContext } from '../../../Context/FileContext';
import { CircularProgress } from '@mui/material';

const AddItemForm = () => {
    const [type, setType] = useState('');
    const [formData, setFormData] = useState({});
    const { files, setShowModal } = useFileContext();
    const [loading, setLoading] = useState(false);


    const handleTypeChange = (e) => {
        setType(e.target.value);
        // Reset form data when type changes
        setFormData({});
    };

    const updateFiles = useCallback(() => {
        if (formData && type && formData[type]) {
            formData[type].files = files || [];
        }
    }, [formData, type, files]);

    useEffect(() => {
        updateFiles();
    }, [files, updateFiles]);

    const handleFormDataChange = (data) => {
        setFormData(prevData => ({ ...prevData, [type]: data }));
    };

    const isFormComplete = () => {
        switch (type) {
            case 'product':
                return formData.product &&
                    formData.product.name &&
                    formData.product.price &&
                    formData.product.quantity &&
                    formData.product.description;
            case 'service':
                return formData.service &&
                    formData.service.name &&
                    formData.service.description &&
                    formData.service.price &&
                    formData.service.duration;
            case 'course':
                return formData.course &&
                    formData.course.title &&
                    formData.course.description &&
                    formData.course.price &&
                    formData.course.duration;
            case 'other':
                return formData.other &&
                    formData.other.name;
            default:
                return false;
        }
    };

    const AddButton = () => (
        <div>
            {!loading ? <button onClick={handleAddClick} disabled={!isFormComplete()}>
                Add
            </button> :
                <CircularProgress />
            }
        </div>
    );

    const handleAddClick = async () => {
        setLoading(true);
        try {
            updateFiles();

            if (type === 'product') {
                await addProduct(formData.product);
                toast.success('Product added successfully', {
                    position: "bottom-right",
                    draggable: true,
                });
            } else if (type === 'course') {
                await addCourse(formData.course);
                toast.success('Course added successfully', {
                    position: "bottom-right",
                    draggable: true,
                });
            } else if (type === 'service') {
                await addService(formData.service);
                toast.success('Service added successfully', {
                    position: "bottom-right",
                    draggable: true,
                });
            }
            setShowModal(false)
        } catch (error) {
            toast.error(`Failed to add item: ${error.message}`, {
                position: "bottom-right",
                draggable: true,
            });
        }
        setLoading(false);
    };

    return (
        <div>
            <h2>Add New Item</h2>
            <select onChange={handleTypeChange}>
                <option value="">Select Type</option>
                <option value="product">Product</option>
                <option value="service">Service</option>
                <option value="course">Course</option>
                <option value="other">Other</option>
            </select>

            {type === 'product' && <ProductDetails onDataChange={handleFormDataChange} />}
            {type === 'service' && <ServiceDetails onDataChange={handleFormDataChange} />}
            {type === 'course' && <CourseDetails onDataChange={handleFormDataChange} />}
            {type === 'other' && <OtherDetails onDataChange={handleFormDataChange} />}

            {type && <AddButton />}
            <ToastContainer />
        </div>
    );
};

export default AddItemForm;
